import styled from "styled-components";
  
export const QuoteOfTheDayContainer = styled.div`
  display:flex;
  flex-direction:column;
`;
  